import { Card, Divider, Typography, Row, Col, Tag } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import GSMDashboard from "../../../components/GSuperMarket/GSMDashboard/GSMDashboard";
import ManageBinService from "../../../services/ManageBinService";
import LoadingSpin from "../../../components/loadingSpin/LoadingSpin";
import "../../../styles/global-ui.css";

const normalize = (value) => String(value || "").trim().toLowerCase();

const isGsmBin = (bin) => normalize(bin?.bin_location) === "garment_super_market";
const isFullBin = (bin) => normalize(bin?.bin_full) === "yes";

const getArrayFromResponse = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.data?.data)) return res.data.data;
  if (Array.isArray(res?.result)) return res.result;
  return [];
};

const GSMDashboardPage = ({ userdata }) => {
  const [gsmBins, setGsmBins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await ManageBinService.getBinData();
        const allBins = getArrayFromResponse(response);
        setGsmBins(allBins);
      } catch (error) {
        console.error("Error fetching GSM dashboard data:", error);
        setGsmBins([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const gsmOnly = useMemo(() => {
    return gsmBins.filter((bin) => isGsmBin(bin) && isFullBin(bin));
  }, [gsmBins]);

  const totalGsmBins = gsmOnly.length;

  const totalGsmPcs = gsmOnly.reduce(
    (sum, bin) => sum + Number(bin?.total_quantity || 0),
    0
  );

  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, "0")}.${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}.${today.getFullYear()}`;

  return (
    <div className="page-container" style={{ position: "relative" }}>
      {loading && (
        <div className="dashboard-overlay-loader">
          <LoadingSpin />
        </div>
      )}

      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            GSM Dashboard
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Garment super market overview and bin activity
          </Typography.Text>
        </div>

        <Tag className="filter-tag" color="blue">
          Date: {formattedDate}
        </Tag>
      </div>

      <Divider className="page-divider" />

      <div className="compact-stats" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 8]} justify="center">
          <Col xs={24} sm={12}>
            <div className="compact-stat-item">
              <div className="compact-stat-value" style={{ color: "#0f172a" }}>
                {loading ? 0 : totalGsmBins}
              </div>
              <div className="compact-stat-label">GSM Bins</div>
            </div>
          </Col>

          <Col xs={24} sm={12}>
            <div className="compact-stat-item">
              <div className="compact-stat-value" style={{ color: "#0f766e" }}>
                {loading ? 0 : totalGsmPcs}
              </div>
              <div className="compact-stat-label">GSM Pieces</div>
            </div>
          </Col>
        </Row>
      </div>

      <Card className="modern-card">
        <GSMDashboard userdata={userdata} gsmBins={gsmBins} loading={loading} />
      </Card>
    </div>
  );
};

export default GSMDashboardPage;